import * as React from 'react';
import styled from '@emotion/styled';
import { colors } from 'styles/colors';
import { Card } from './Card';
import { SoloButton } from './SoloButton';
import { Loading } from './Loading';
import './CTACard.css';

interface CTACardProps {
  title: string;
  icon?: React.ReactNode;
  content: React.ReactNode;
  ctaText: string;
  onCTAClick: () => any;
  notReady?: boolean;
  'data-testid'?: string;
}

export const CTACard = ({ title, icon, content, ctaText, onCTAClick, notReady, 'data-testid': testId }: CTACardProps) => {
  return (
    <Card data-testid={testId}>
      <>
        <div className='card-heading'>
          <div className='card-title'>{title}</div>
          <div className='card-icon-holder'>{icon}</div>
        </div>
        {notReady ? (
          <div style={{ paddingTop: '10px' }}>
            <Loading center={true} />
          </div>
        ) : (
          <>
            <div className='card-content'>{content}</div>
            <div className='card-cta'>
              <SoloButton text={ctaText} onClick={onCTAClick} />
            </div>
          </>
        )}
      </>
    </Card>
  );
};
